// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3OgzP","sendOtp":"AuthorizeToLogin_sendOtp__3ugPG"};